<template>
  <div class="type-dropdown">
    <PillDropdown
      name="Type"
      :options="types"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import PillDropdown from './PillDropdown.vue';
const { $t } = useNuxtApp();
const route = useRoute();

const types = computed(() => {
  const allTypes = [
    { name: $t('search.events.tagName'), type: 'events', idx: 0, checked: false },
    { name: $t('search.documents.tagName'), type: 'assets', idx: 1, checked: false },
    { name: $t('search.athletics.tagName'), type: 'athletics', idx: 2, checked: false },
    { name: $t('search.staff.tagName'), type: 'staff', idx: 3, checked: false },
    { name: $t('search.forms.tagName'), type: 'forms', idx: 4, checked: false },
    { name: $t('search.liveFeed.tagName'), type: 'live_feeds', idx: 5, checked: false },
    { name: $t('search.articles.tagName'), type: 'news', idx: 6, checked: false },
    { name: $t('search.links.tagName'), type: 'links', idx: 7, checked: false },
    { name: $t('search.pages.tagName'), type: 'pages', idx: 8, checked: false },
  ];
  allTypes.map((org, index) => {
    if (route.query?.query_indices?.includes(org.type)) {
      return (allTypes[index].checked = true);
    }
  });
  return allTypes;
});
</script>
